import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import CookMode from './pages/CookMode'
import AppLayout from './layout/AppLayout'
import Library from './pages/Library'
import RecipeDetail from './pages/RecipeDetail'
import Home from './pages/Home'
import Collections from './pages/Collections'
import Favourites from './pages/Favourites'
import NewRecipeForm from './pages/NewRecipeForm'
import EditRecipe from './pages/EditRecipe'
import RecipeHistory from './pages/RecipeHistory'
import Search from './pages/Search'
import CollectionDetail from './pages/CollectionDetail'
import Settings from './pages/Settings'
import Preferences from './pages/Preferences'
import QuickRecipes from './pages/QuickRecipes'
import RecentlyViewed from './pages/RecentlyViewed'
import MealPlan from './pages/MealPlan'
import ShoppingList from './pages/ShoppingList'
import CookFromPantry from './pages/CookFromPantry'
import NotFound from './pages/NotFound'
import { ScrollToTop } from './components/ScrollToTop'
import { PostHogTracker } from './components/PostHogTracker'
import { ConsentBanner } from './components/ConsentBanner'

function App() {
  return (
    <>
      <BrowserRouter>
      <ScrollToTop />
      <PostHogTracker />
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/recipes" element={<Library />} />
          <Route path="/search" element={<Search />} />
          <Route path="/recipes/new" element={<NewRecipeForm />} />
          <Route path="/recipe/:id" element={<RecipeDetail />} />
          <Route path="/recipe/:id/edit" element={<EditRecipe />} />
          <Route path="/recipe/:id/history" element={<RecipeHistory />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/collection/:id" element={<CollectionDetail />} />
          <Route path="/favourites" element={<Favourites />} />
          <Route path="/quick-recipes" element={<QuickRecipes />} />
          <Route path="/recently-viewed" element={<RecentlyViewed />} />
          <Route path="/meal-plan" element={<MealPlan />} />
          <Route path="/shopping-list" element={<ShoppingList />} />
          <Route path="/what-can-i-make" element={<CookFromPantry />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/preferences" element={<Preferences />} />
          {/* Catch-all: unknown routes render the 404 inside the app chrome */}
          <Route path="*" element={<NotFound />} />
        </Route>
        {/* Cook mode is full-screen/no-chrome, so it sits outside AppLayout */}
        <Route path="/recipe/:id/cook" element={<CookMode />} />
      </Routes>
    </BrowserRouter>
    <ConsentBanner />
    </>
  )
}

export default App
